import type { ComponentProps } from 'react';

import { Checkbox, Table } from 'rsuite';

const { Cell } = Table;

export type DataGridCheckRow = string | number;

export interface CheckCellProps extends Omit<
  ComponentProps<typeof Cell>,
  'onChange'
> {
  onChange: ComponentProps<typeof Checkbox>['onChange'];
  checkedKeys: DataGridCheckRow[];
  dataKey: string;
  rowData?: Record<string, any>;
}

const CheckCell = ({
  onChange,
  checkedKeys,
  dataKey,
  ...props
}: CheckCellProps) => {
  const rowData = props.rowData || {};
  return (
    <Cell {...props}>
      <div className="flex items-center h-full w-full px-4 py-2 select-none">
        <Checkbox
          value={rowData?.[dataKey]}
          inline
          onChange={onChange}
          checked={checkedKeys.some((item) => item === rowData?.[dataKey])}
        />
      </div>
    </Cell>
  );
};

export default CheckCell;
